import * as types from "./actionTypes";

export const bookingsSetIsLoading = (isLoading) => ({
  type: types.BOOKING_SET_IS_LOADING,
  payload: isLoading,
});

export const bookingsSetData = (bookings) => ({
  type: types.BOOKING_SET_DATA,
  payload: bookings,
});

export const bookingsRequestData = () => ({
  type: types.BOOKING_REQUEST_DATA,
});
